<template>
    <div>

        <!-- Flat view button -->

        <button class="btn btn-white btn-sm" @click="openFlightHours()">
            <i class="material-icons" style="position:relative;top:-1px;margin-right:5px;">flight</i>
            {{ lang.polaris.dashboard.flight_hours }}
        </button>

        <!-- Flight hours modal -->
        <trax-ui-modal-plain-header :id="id+'-modal'" :bus="bus">
            <enac-custom-atpl-phase-flight-hours-popup :id="id" :bus="bus" :course-id="courseId">
            </enac-custom-atpl-phase-flight-hours-popup>
        </trax-ui-modal-plain-header>

    </div>
</template>

<script>
    export default {
    
        props: {
            id: {default: 'enac-custom-phase-flight-hours'},
            courseId: null
        },
    
        data: function() {
            return {
                lang: lang,
                bus: new Vue()
            }
        },

        methods: {

            openFlightHours() {
                this.bus.$emit(this.id+'-modal-open', { icon: 'flight', title: this.lang.polaris.dashboard.flight_hours });
            }
        }
    }
</script>
